import { useEffect, useState } from "react";
import { fetchJobIdsForWebsite } from "../../core/api/jobsApi";
import { websiteInSearch } from "../../core/data/jobs";

// Waits this long after the last key before looking a website up.
const PAUSE_MS = 400;

// When the Audits search box holds a website, which of the account's
// snapshots saw it. { domain, searching, jobIds }: domain is null when the
// text isn't a website; jobIds is null until the lookup finishes.
export default function useWebsiteSearch(agencyId, text) {
  const domain = websiteInSearch(text);
  const [found, setFound] = useState({ domain: null, jobIds: null });

  useEffect(() => {
    if (!domain || !agencyId) return undefined;
    let cancelled = false;
    const timer = setTimeout(async () => {
      const jobIds = await fetchJobIdsForWebsite(agencyId, domain);
      if (!cancelled) setFound({ domain, jobIds });
    }, PAUSE_MS);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [agencyId, domain]);

  const jobIds = found.domain === domain ? found.jobIds : null;
  return { domain, searching: Boolean(domain) && jobIds === null, jobIds };
}
